import React, {PureComponent} from "react";
import PropTypes from "prop-types";

export default class CartItem extends PureComponent {
    constructor(props){
        super(props);

        this.state = {
            qtySelected: 1
        };

        this.handleQtyUpdate = this.handleQtyUpdate.bind(this);
    }

    handleQtyUpdate(e){
        let {
            item_id,
            name,
            price,
            product_type,
            qty,
            quote_id,
            sku
        } = this.props;

        let detailsCopy = {
            item_id: item_id,
            name: name,
            price: price,
            product_type: product_type,
            qty: qty,
            quote_id: quote_id,
            sku: sku
        };

        detailsCopy.qty = e.target.value;

        const newQty = {
            cartItem: detailsCopy
        };

        this.setState({
            qtySelected: detailsCopy.qty
        }, ()=>{
            this.props.qtyChange(this.props.item_id, newQty);
        });
    }

    componentDidMount(){
        this.setState({
            qtySelected: this.props.qty
        });
    }

    componentDidUpdate(){
        if(this.props.qty !== this.state.qtySelected){
            this.setState({
                qtySelected: this.props.qty
            });
        }
    }

    render() {
        return (
            <div className="list-group-item vendor-item">
                <div className="row">
                    <div className="col-md-3 col-sm-12">
                        <img
                            className="w-100"
                            src={`${localStorage.getItem("restUrl")}/pub/media/catalog/product${this.props.product_attributes.thumbnail}`}
                            onError={this.addDefaultSrc}
                        />
                    </div>
                    <div className="col-md-7 col-sm-12">
                        <a href="">
                            <h5>{this.props.name}</h5>
                        </a>
                        <p className="text-muted">{this.props.sku}</p>
                        <a href=""
                            className="text-danger"
                            onClick={
                                (e) => {
                                    e.preventDefault();
                                    this.props.removeItem(this.props.item_id);
                                }
                            }>Remove Item
                        </a>
                    </div>
                    <div className="col-md-2 col-sm-12">
                        <h5>{`USD$${this.props.price}`}</h5>
                        <label htmlFor="qty">Qty</label>
                        <input
                            readOnly={this.props.readOnly}
                            id="qty"
                            className="qty form-control"
                            type="number"
                            value={this.state.qtySelected}
                            onChange={this.handleQtyUpdate} />
                    </div>
                </div>
            </div>
        );
    }
    addDefaultSrc(e) {
        e.target.src = "/images/image-not-found.png";
    }
}

CartItem.defaultProps = {
    product_attributes: {
        thumbnail: "/junk.png",
    },
    readOnly: false
};

CartItem.propTypes = {
    readOnly: PropTypes.bool,
    item_id: PropTypes.number,
    name: PropTypes.string,
    sku: PropTypes.string,
    price: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    qty: PropTypes.number,
    product_attributes: PropTypes.object,
    product_type: PropTypes.string,
    quote_id: PropTypes.string,
    removeItem: PropTypes.func,
    qtyChange: PropTypes.func,
};
